import type { Feature, FeatureFlag } from "@/store/features/features";
import { FaroText } from "@faro-lotv/flat-ui";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import type { JSX } from "react";
import { FeaturesDialogRow } from "./features-dialog-row";

type DevFeaturesTableProps = {
  entries: Array<[FeatureFlag, Feature]>;
};

/** @returns The filtered experimental features table. */
export function DevFeaturesTable({
  entries,
}: DevFeaturesTableProps): JSX.Element {
  return (
    <Table sx={{ width: "100%" }}>
      <TableHead>
        <TableRow>
          <TableCell align="left" sx={{ p: 1 }}>
            <FaroText variant="helpText">Name</FaroText>
          </TableCell>
          <TableCell align="left" sx={{ p: 1 }}>
            <FaroText variant="helpText">Description</FaroText>
          </TableCell>
          <TableCell align="left" sx={{ p: 1 }}>
            <FaroText variant="helpText">Enabled</FaroText>
          </TableCell>
          <TableCell align="left" sx={{ p: 1 }}>
            <FaroText variant="helpText">Value</FaroText>
          </TableCell>
          <TableCell align="left" sx={{ p: 1 }}>
            <FaroText variant="helpText">Available since</FaroText>
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {entries.map(([name, properties]) => (
          <FeaturesDialogRow key={name} name={name} {...properties} />
        ))}
      </TableBody>
    </Table>
  );
}
